import {
  SET_CURRENCY,
  ADD_ITEM,
  REMOVE_ITEM,
  SET_TICKETS,
  FILTER_TICKETS,
  CALCULATE_COST,
  CLEAR_PRICE,
  SET_SLUG
} from 'context/constants';

export const setCurrency = currency => ({
  type: SET_CURRENCY,
  payload: currency
});

export const setTickets = tickets => ({
  type: SET_TICKETS,
  payload: tickets
});

export const setSlug = slug => ({
  type: SET_SLUG,
  payload: slug
});

export const addItem = item => ({
  type: ADD_ITEM,
  payload: item
});

export const removeItem = item => ({
  type: REMOVE_ITEM,
  payload: item
});

export const filterTickets = () => ({
  type: FILTER_TICKETS
});

export const calculateCost = () => ({
  type: CALCULATE_COST
});

export const clearPrice = () => ({
  type: CLEAR_PRICE
});
export const clearIsFree = () => ({
  type: 'CLEAR_IS_FREE'
});
export const setIsFree = isFree => ({
  type: 'SET_IS_FREE',
  payload: isFree
});
